<template>
  <div class="w-screen h-screen fixed items-center justify-center bg-black bg-opacity-40" style="z-index: 5000;  backdrop-filter: blur(7.5px);">
    <div class="w-full flex flex-col max-w-xl bg-white rounded-2xl p-4">
      <WcTypography size="md" weight="600" :title="t('outDatedApp')" />
      <div class="w-full flex max-w-xl">
        <div class="flex flex-col justify-between my-2.5 pt-3">
          <WcTypography size="sm" :title="t('youAreUsingOutDatedAppPleaseUpdate')" />
          <Button type="primary" @click="click">{{t('updateNow')}}</Button>
        </div>
        <div class="w-80 h-40">
          <WcIconOutDatedApp />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import WcDialog from '@/components/UILibrary/WcDialog.vue'
import { isMobile } from '@/utils/general'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import Button from '@/components/UILibrary/Buttons/Button.vue'
import WcIconOutDatedApp from '@/components/UILibrary/Icons/WcIconOutDatedApp.vue'
import WcIconExternalLink from '@/components/UILibrary/Icons/WcIconExternalLink.vue'
import WcIconScheduleInterview from '@/components/UILibrary/Icons/WcIconScheduleInterview.vue'

@Component({
  methods: { isMobile },
  components: { WcIconScheduleInterview, WcIconExternalLink, WcIconOutDatedApp, Button, WcTypography, WcDialog }
})
export default class OutDatedApp extends Vue {
  click(): void {
    this.$emit('click')
  }

  t(key: string): string {
    return this.$t(`general.${key}`).toString()
  }
}

</script>

<style scoped>

</style>
